export default __webpack_public_path__ + "static/media/paypal1.a62e67aa.png";